import * as zip from '@zip.js/zip.js';

import { FileFromZip } from './files/FileFromZip';

export async function extractUploadedFilesFromZip(zipContents: string) {
  const reader = new zip.ZipReader(new zip.Data64URIReader(zipContents));
  const entries = await reader.getEntries();
  const fileEntries = entries.filter((e) => !e.directory);
  return fileEntries.map((entry) => new FileFromZip(entry));
}
